/*
 * Descarga de la factura en Mi cuenta (myaccount/view-order.php).
 *
 * La web pide el PDF a Business Central en el momento y tarda unos segundos. Con un enlace
 * normal parece que no pasa nada, así que se descarga por fetch mientras se muestra el aviso
 * de carga, y al terminar se guarda con el nombre que manda el servidor. Si el servidor
 * responde con su página de error, se muestra su mensaje debajo del enlace.
 * Sin JS el enlace sigue funcionando, solo que sin aviso.
 */

const filenameFrom = (response) => {
    const match = /filename="([^"]+)"/.exec(response.headers.get('Content-Disposition') || '');
    return match ? match[1] : 'invoice.pdf';
};

const saveBlob = (blob, filename) => {
    const url = URL.createObjectURL(blob);
    const anchor = document.createElement('a');

    anchor.href = url;
    anchor.download = filename;
    document.body.append(anchor);
    anchor.click();
    anchor.remove();

    setTimeout(() => URL.revokeObjectURL(url), 1000);
};

/* El servidor devuelve una página HTML con el título y el motivo: se reaprovecha su texto
   para no duplicar aquí los mensajes ni sus traducciones. */
const errorMessageFrom = async (response) => {
    const page = new DOMParser().parseFromString(await response.text(), 'text/html');
    const title = page.querySelector('h1')?.textContent.trim() || '';
    const detail = page.querySelector('p')?.textContent.trim() || '';

    return [title, detail].filter(Boolean).join('. ');
};

const setLoading = (root, loading) => {
    root.querySelector('[data-invoice-download-label]').classList.toggle('hidden', loading);

    const indicator = root.querySelector('[data-invoice-download-loading]');
    indicator.classList.toggle('hidden', !loading);
    indicator.classList.toggle('inline-flex', loading);

    root.querySelector('[data-invoice-download-link]').setAttribute('aria-busy', String(loading));
};

const showError = (root, message) => {
    const box = root.querySelector('[data-invoice-download-error]');

    box.textContent = message;
    box.classList.toggle('hidden', !message);
};

const download = async (root, link) => {
    showError(root, '');
    setLoading(root, true);

    try {
        const response = await fetch(link.href, { credentials: 'same-origin' });
        const type = response.headers.get('Content-Type') || '';

        if (response.ok && type.includes('application/pdf')) {
            saveBlob(await response.blob(), filenameFrom(response));
            return;
        }

        const message = await errorMessageFrom(response);
        if (!message) {
            window.location.href = link.href;
            return;
        }
        showError(root, message);
    } catch (error) {
        // Red caída o respuesta ilegible: el enlace normal muestra lo que haya
        window.location.href = link.href;
    } finally {
        setLoading(root, false);
    }
};

document.addEventListener('click', (event) => {
    const link = event.target.closest('[data-invoice-download-link]');

    if (!link) {
        return;
    }

    event.preventDefault();

    // Un segundo clic mientras carga no lanza otra descarga
    if (link.getAttribute('aria-busy') === 'true') {
        return;
    }

    download(link.closest('[data-invoice-download]'), link);
});
